import Map, { Marker, ViewState } from 'react-map-gl/maplibre';
import 'maplibre-gl/dist/maplibre-gl.css';
import { FC, useEffect, useState } from 'react';
import { ExtendedFeature, geoCentroid, GeoGeometryObjects } from 'd3-geo';
import { GeoJsonProperties } from 'geojson';
import { MarkerProp } from './_models';
import IconSVG from '../IconSVG';

interface Props {
  markers: MarkerProp[];
  selectedGeo: ExtendedFeature<
    GeoGeometryObjects | null,
    GeoJsonProperties
  > | null;
}

const MapChart: FC<Props> = ({ markers, selectedGeo }) => {
  const [viewState, setViewState] = useState<ViewState>({
    latitude: 20,
    longitude: 0,
    zoom: 1.2,
    bearing: 0,
    pitch: 0,
    padding: { top: 0, bottom: 0, left: 0, right: 0 },
  });

  useEffect(() => {
    if (selectedGeo) {
      const [lng, lat] = geoCentroid(selectedGeo);
      setViewState((prev) => ({
        ...prev,
        latitude: lat,
        longitude: lng,
        zoom: 4,
      }));
    }
  }, [selectedGeo]);

  const handleMove = ({ viewState: vs }: { viewState: ViewState }) => {
    if (selectedGeo) return; // bloqueia movimento enquanto país selecionado

    setViewState((prev) => {
      const same =
        Math.abs(prev.latitude - vs.latitude) < 1e-6 &&
        Math.abs(prev.longitude - vs.longitude) < 1e-6 &&
        Math.abs(prev.zoom - vs.zoom) < 1e-6;

      return same ? prev : vs; // só actualiza se mudou
    });
  };

  return (
    <Map
      {...viewState}
      onMove={handleMove}
      style={{ width: '100%', height: '100%' }}
      mapStyle="https://basemaps.cartocdn.com/gl/positron-gl-style/style.json"
    >
      {markers.map((m) => (
        <Marker
          key={m.id}
          longitude={m.coordinates[0]}
          latitude={m.coordinates[1]}
          anchor="bottom"
          onClick={m.onClick}
          style={{ cursor: 'pointer' }}
        >
          <IconSVG name="pole" stroke="#00bd00" stroke-width={5} />
        </Marker>
      ))}
    </Map>
  );
};

export default MapChart;
